import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { ToolbarButton, type ToolbarButtonProps } from './ToolbarButton';

const ButtonGroup = styled(Space.Compact)`
  display: flex;
`;

export interface NeighborButtonsProps {
  previous?: ToolbarButtonProps;
  next?: ToolbarButtonProps;
}

export function NeighborButtons({ previous, next }: NeighborButtonsProps) {
  return (
    <ButtonGroup>
      <ToolbarButton {...previous}>
        <CaretLeftOutlined />
      </ToolbarButton>

      <ToolbarButton {...next}>
        <CaretRightOutlined />
      </ToolbarButton>
    </ButtonGroup>
  );
}
